<template>
<div class="credit-bureau-list">
  <!-- <div v-if="contractId === -1 && !isHideDateBar && activeExpandContractId === -1" class="header-nav shadow-sm pr-4 pl-4 d-flex align-items-center">
    <span class="text-secondary"><small>ข้อมูลวันที่ {{$dayjs().subtract(6, 'month').format('DD MMM YYYY')}} - {{$dayjs().format('DD MMM YYYY')}}</small></span>
    <button v-if="showPrintButton" class="btn btn-primary btn-sm rounded-pill ml-2 float-right">บันทึกเอกสาร</button>
  </div> -->
  <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="populateList()"></error-cant-reach-server>
  <error-not-enough-money-for-credit class="mt-2 mr-2 ml-2" v-if="isNotEnoughMoney"></error-not-enough-money-for-credit>
  <div class="container text-center">
    <div class="spinner-border text-primary text-center m-4" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <template v-if="!isLoading">
    <template v-if="isShowSearch">
      <div class="header-nav shadow-sm pr-3 pl-3 border-bottom">
          <ul class="nav nav-tabs nav-fill">
              <li class="nav-item">
                <a class="nav-link px-1" style="font-size: 12px;" @click.prevent="activeUserSide = 'KORGOO'" :class="{ 'active': activeUserSide === 'KORGOO' }">บัญชีเจ้าหนี้ของคุณ</a>
              </li>
              <li class="nav-item">
                <a class="nav-link px-1" style="font-size: 12px;" @click.prevent="activeUserSide = 'HAIGOO'" :class="{ 'active': activeUserSide === 'HAIGOO' }">บัญชีลูกหนี้ของคุณ</a>
              </li>
          </ul>
      </div>
      <SearchBar placeholder="ค้นหาสัญญา" v-model="creditSearchString"></SearchBar>
      <div v-if="creditSearchString !== ''" class="container pl-4 pr-4 pt-1 pb-2 bg-white text-primary">
        พบ {{creditbureaus.length}} สัญญา ที่มี "{{creditSearchString}}" ในประวัติเครดิต
      </div>
    </template>
    <ul v-if="activeExpandContractId === -1" class="list-group list-group-flush">
      <template v-for="credit in creditbureaus">
        <button class="list-group-item list-group-item-action p-4" :key="'cred-' + credit.id" @click="navigate(credit)" v-if="!(credit.daysLate === 0 && credit.isPaid === false)">
          <div class="row">
              <div class="col-1 p-0">
                  <p v-if="credit.daysLate <= 30" class="bullet-dot text-success">•</p>
                  <p v-if="credit.daysLate >= 31 && credit.daysLate <= 60" class="bullet-dot text-warning">•</p>
                  <p v-if="credit.daysLate >= 61 && credit.daysLate <= 90" class="bullet-dot text-danger">•</p>
                  <p v-if="credit.daysLate >= 91" class="bullet-dot text-dark">•</p>
                  <p v-if="credit.daysLate === 0 && credit.isPaid === false" class="bullet-dot text-primary">•</p>
              </div>
              <div class="col-7 pl-2">
                  <p class="m-0">
                    สัญญากู้เงิน/ซื้อขาย #{{credit.contractNo}}: {{credit.period}}/{{credit.totalPeriod}}
                    <span v-if="credit.isLastPeriod" class="ml-1">(งวดสุดท้าย)</span>
                    <span v-if="credit.isCanceled" class="ml-1 badge badge-secondary">ผู้ให้กู้ยกหนี้</span>
                  </p>
                  <template v-if="!credit.isCanceled">
                    <p v-if="credit.daysLate <= 30" class="m-0 text-secondary">
                      <small v-if="credit.isPaid === true">ชำระแล้ว </small><small v-if="credit.isPaid === false">ยังไม่ได้ชำระ </small>
                      <small>ไม่ค้างชำระหรือค้างไม่เกิน 30 วัน</small>
                    </p>
                    <p v-if="credit.daysLate >= 31 && credit.daysLate <= 60" class="m-0 text-secondary">
                      <small v-if="credit.isPaid === true">ชำระแล้ว </small><small v-if="credit.isPaid === false">ยังไม่ได้ชำระ </small>
                      <small>ค้างชำระ 31-60 วัน</small>
                    </p>
                    <p v-if="credit.daysLate >= 61 && credit.daysLate <= 90" class="m-0 text-secondary">
                      <small v-if="credit.isPaid === true">ชำระแล้ว </small><small v-if="credit.isPaid === false">ยังไม่ได้ชำระ </small>
                      <small>ค้างชำระ 61-90 วัน</small>
                    </p>
                    <p v-if="credit.daysLate >= 91" class="m-0 text-secondary">
                      <small v-if="credit.isPaid === true">ชำระแล้ว </small><small v-if="credit.isPaid === false">ยังไม่ได้ชำระ </small>
                      <small>ค้างชำระมากกว่า 90 วัน</small>
                    </p>

                    <p v-if="credit.daysLate === 0 && credit.isPaid === false">
                      <small>(ยังไม่ถึงกำหนดชำระ)</small>
                    </p>
                  </template>
              </div>
              <div class="col-4 text-right">
                  <p v-if="activeUserSide === 'HAIGOO'" class="m-0">{{credit.amount | money}}</p>
                  <p v-if="activeUserSide === 'KORGOO'" class="m-0 text-danger">{{credit.amount | money}}</p>
                  <p class="m-0 text-secondary"><small>{{ $dayjs(credit.dueDate).format('D MMM YYYY') }}</small></p>
              </div>
          </div>
        </button>
      </template>
    </ul>
    <div v-else class="bg-white">
      <div class="header-nav shadow-sm pr-4 pl-4 d-flex flex-column justify-content-center" style="height: 84px;">
        <button class="btn btn-primary btn-sm mb-2" style="max-width: 96px;" @click="activeExpandContractId = -1">← ย้อนกลับ</button>
        <span class="text-secondary">ข้อมูลสัญญา #{{activeExpandContractNo}}</span>
      </div>
      <div class="container p-0">
        <CreditBureauList :isHideDateBar="true" :isAllowNavigate="false" :contractId="activeExpandContractId" :userId="userId" :showPrintButton="false"></CreditBureauList>
      </div>
      <!-- <div class="container text-center">
        <div class="spinner-border text-primary text-center m-4" role="status" v-if="isLoading">
          <span class="sr-only">Loading...</span>
        </div>
      </div> -->
    </div>
  </template>
</div>
</template>

<script>
import SearchBar from './SearchBar'

export default {
  name: 'CreditBureauList',
  data: () => ({
    activeUserSide: 'KORGOO',
    creditSearchString: '',

    activeExpandContractId: -1,
    isLoading: false,
    isCantReach: false,
errorData: {},
    isNotEnoughMoney: false,
    creditbureaus: [],
    creditbureausAll: []
  }),
  watch: {
    activeUserSide () {
      this.filterList(this.activeUserSide)
    },
    creditSearchString (to) {
      if (to === '') {
        this.filterList(this.activeUserSide)
      } else {
        this.filterList(this.activeUserSide, to)
      }
    }

  },
  async mounted () {
    await this.populateList()
    if (this.isShowSearch) await this.filterList(this.activeUserSide)
  },
  methods: {
    async populateList() {
      this.list = []
      this.isLoading = true
      let result;
      if (this.isOnlyContract) {
        result = await this.$api.creditbureau.listOnlyContract(this.userId, this.contractId)
      } else {
        result = await this.$api.creditbureau.list(this.userId, this.contractId)
      }
      const data = result.data
      if (!data.success) {
        if (data.code === 'W-MONEY_INSUFFICENT') {
          this.isNotEnoughMoney = true
          this.isLoading = false
        } else {
          this.isCantReach = true
this.errorData = data
        }
        return
      }
      let dataCredit = data.creditbureaus
      if (this.contractId !== -1) {
        dataCredit = dataCredit.filter(elm => elm.contractId === this.contractId)
      }
      this.creditbureaus = dataCredit
      this.creditbureausAll = dataCredit
      this.isLoading = false
    },
    async filterList(activeUserSide, search = '') {
      this.isLoading = true
      this.creditbureaus = []
      this.creditbureaus = this.creditbureausAll.filter((elm) => {
        return elm.activeUserSide === activeUserSide
      })
      if (search !== '') {
        this.creditbureaus = this.creditbureaus.filter(
          elm => (
            elm.contractNo.toString().includes(search.toLowerCase())
          )
        )
      }
      this.isLoading = false
    },
    navigate (creditbureau) {
      if (this.isAllowNavigate) window.location.assign(`${window.BASE_URL}member/credit#/view-contract/${creditbureau.contractId}`)
      if (this.isExpandable) {
        this.activeExpandContractId = creditbureau.contractId
        this.activeExpandContractNo = creditbureau.contractNo
      }
    },
  },
  props: {
    userId: {
      type: Number,
      default: -1
    },
    contractId: {
      type: Number,
      default: -1
    },
    showPrintButton: {
      type: Boolean,
      default: true
    },
    isAllowNavigate: {
      type: Boolean,
      default: false
    },
    isOnlyContract: {
      type: Boolean,
      default: false
    },
    isExpandable: {
      type: Boolean,
      default: false
    },
    isHideDateBar: {
      type: Boolean,
      default: false
    },
    isShowSearch: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SearchBar
  }
}
</script>

<style lang="scss">
</style>
